import * as React from 'react';
import { ToolLine } from '@mingcute/react';

import { cn } from '../lib/cn';

export interface MaintenanceBannerProps extends React.HTMLAttributes<HTMLDivElement> {
  message: React.ReactNode;
  eta?: string;
}

export const MaintenanceBanner = React.forwardRef<HTMLDivElement, MaintenanceBannerProps>(
  ({ className, message, eta, ...props }, ref) => (
    <div
      ref={ref}
      role="status"
      className={cn(
        'sticky top-0 z-[var(--z-sticky)] flex w-full items-center gap-3 border-b border-[var(--color-info-dark)]',
        'bg-[var(--color-info)] px-4 py-2 text-sm text-[var(--tvl-on-accent)]',
        className,
      )}
      {...props}
    >
      <ToolLine size={16} className="shrink-0" aria-hidden />
      <div className="flex-1 min-w-0">
        <span className="font-semibold">{message}</span>
        {eta ? <span className="ml-2 opacity-90">ETA: {eta}</span> : null}
      </div>
    </div>
  ),
);
MaintenanceBanner.displayName = 'MaintenanceBanner';
